// Growth › Previews labels and helpers, shared by its pages and the lead page.

import type { Preview, PreviewStatus } from '@/api/types'

export const PREVIEW_STATUS_LABELS: Record<PreviewStatus, string> = {
  active: 'Live',
  expired: 'Ended',
  removed: 'Deleted',
  claimed: 'Converted',
}

/** The address without its scheme, as people say it: riverside-hoops.scorelm.com. */
export function addressText(p: Pick<Preview, 'address'>): string {
  return p.address ? p.address.replace(/^https?:\/\//, '') : '—'
}

export function daysLeftText(p: Pick<Preview, 'status' | 'days_left'>): string {
  if (p.status !== 'active') return '—'
  return `${p.days_left} ${p.days_left === 1 ? 'day' : 'days'}`
}

export const LIFE_OPTIONS = [
  { value: '15', label: '15 days' },
  { value: '30', label: '30 days' },
  { value: 'custom', label: 'Custom' },
]

/** The picked number of days, or null while a custom value isn't one. */
export function daysFrom(choice: string, custom: string): number | null {
  if (choice !== 'custom') return Number(choice)
  const n = Number(custom)
  return /^\d+$/.test(custom) && n >= 1 && n <= 365 ? n : null
}
